import { Tipo_solicitud } from './../../../models/tipo_solicitud.model';
import { Component } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { GLOBAL } from 'src/app/services/global';

export interface Solicitud {
    optradio: string;
}

@Component({
    selector: "page-tipo_solicitud",
    templateUrl: "./tipo_solicitud.component.html",
    styleUrls: ["./tipo_solicitud.component.css"]

})


export class Tipo_solicitudComponent {

    public acotado = GLOBAL.acotado;
    public rows = [];
    public actualRow;
    public tipo_solicitud: Tipo_solicitud;
    public tipo_sol = new FormControl('');
    public form;
    public formchecks;
    public solicitud = { "AMPLIACIÓN MENOR A 100 M2": false, "MODIFICACIÓN": false, "ART 6 2 9 OGUC": false }
    public solicitud2 = { "": false }

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [ENTER];
    sols: Solicitud[] = [];








    constructor(private fb: FormBuilder) {
        if (this.acotado != true) {

            /*  if (!JSON.parse(localStorage.getItem("tipo_solicitud"))) {
                 localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));
             } else {
                 this.rows = JSON.parse(localStorage.getItem("tipo_solicitud"));
                 this.solicitud = {
                     "AMPLIACIÓN MENOR A 100 M2": 'SI' ? this.rows[0].optradio["AMPLIACIÓN MENOR A 100 M2"] : 'NO',
                     "MODIFICACIÓN": 'SI' ? this.rows[0].optradio["MODIFICACIÓN"] : 'NO',
                     "ART 6 2 9 OGUC": 'SI' ? this.rows[0].optradio["ART 6 2 9 OGUC"] : 'NO'
     
     
     
                 }
             } */


            this.formchecks = new FormGroup({
                solicitud1: new FormControl(''),
                solicitud2: new FormControl(''),
                solicitud3: new FormControl('')
            })

            if (!JSON.parse(localStorage.getItem("tipo_solicitud"))) {
                console.log('nuevo')
                this.rows = [{
                    optradio: this.solicitud
                }]
                console.log('nuevo this.rows', this.rows);
                localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));

            } else {
                console.log('desde borrador');
                this.rows = JSON.parse(localStorage.getItem("tipo_solicitud"));
                this.formchecks.controls['solicitud1'].setValue(this.rows[0] /*existe*/ ? this.rows[0].optradio["AMPLIACIÓN MENOR A 100 M2"] : false);
                this.formchecks.controls['solicitud2'].setValue(this.rows[0] ? this.rows[0].optradio["MODIFICACIÓN"] : false);
                this.formchecks.controls['solicitud3'].setValue(this.rows[0] ? this.rows[0].optradio["ART 6 2 9 OGUC"] : false);
            }
        } else{
            console.log(JSON.parse(localStorage.getItem("tipo_sol")));

            if (JSON.parse(localStorage.getItem("tipo_sol"))) {
                console.log('desde borrador');
                this.sols = JSON.parse(localStorage.getItem("tipo_sol"));
               
            }
        }
    }

    ngOnInit() {
        this.form = localStorage.getItem('form');
        console.log("Formulario seleccionado", this.form)


    }

    add_tipo_sol(tipoSol) {
        console.log('Value', tipoSol)
        localStorage.setItem("tipo_solicitud", tipoSol);
        console.log('Storage', localStorage.getItem("tipo_solicitud"));
    }

    /* add_tipo_solicitud() {

        localStorage.setItem("tipo_solicitud", JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_solicitud");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            optradio: this.solicitud


        })
        console.log(this.rows);

        localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_solicitud")));

    }
 */
    add_tipo_solicitud() {
        this.solicitud = {
            "AMPLIACIÓN MENOR A 100 M2": this.formchecks.value.solicitud1,
            "MODIFICACIÓN": this.formchecks.value.solicitud2,
            "ART 6 2 9 OGUC": this.formchecks.value.solicitud3,
        }
        this.rows = [{
            optradio: this.solicitud
        }]
        console.log('add_tipo_solicitud this.rows', this.rows);
        localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));
    }

    delete_tipo_solicitud(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_solicitud", JSON.stringify(this.rows));
            }
        }
    }


    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        localStorage.setItem("tipo_sol", JSON.stringify([]));
        // Add our fruit
        if ((value || '').trim()) {
            this.sols.push({
                optradio: value.trim()
            });
        }

        console.log(this.sols)
        localStorage.setItem("tipo_sol", JSON.stringify(this.sols));
        console.log(JSON.parse(localStorage.getItem("tipo_sol")));
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(sols: Solicitud): void {
        localStorage.setItem("tipo_sol", JSON.stringify([]));
        const index = this.sols.indexOf(sols);

        if (index >= 0) {
            this.sols.splice(index, 1);
        }

        localStorage.setItem("tipo_sol", JSON.stringify(this.sols));
        console.log(JSON.parse(localStorage.getItem("tipo_sol")));
    }
}